import ThumbImg from './thumb.png';

export default {
  thumb: ThumbImg,
  url: '/cryptopunks',
  footnote: '',
  avatar: '',
  author: '',
};
